<template>
<div
    :class="[
        'calendar-card',
        `calendar-card--theme-${theme}`
    ]"
    v-if="data"
>
    <div class="calendar-card__content">
        <date-block
            size="m"
            :date="data.dateFrom.timestamp"
            :date-end="data.dateTo.timestamp"
            class="u-bottom-margin--s"
        />

        <z-caption class="calendar-card__title" size="m" weight="500">
            <span v-html="data.name"></span>
        </z-caption>
    </div>
    <div class="calendar-card__footer" v-if="theme === 'upcoming' || data.file && data.file.link">
        <remind :data="data.remind" v-if="theme === 'upcoming'">
            <z-button size="s" kind="secondary">
                <span v-html="text.addToCalendar"></span>
                <template v-slot:right>
                    <z-icon
                        name="calendar"
                        width="24"
                        height="24"
                    ></z-icon>
                </template>
            </z-button>
        </remind>
        <template v-else>
            <z-link
                v-if="data.file && data.file.link"
                :href="data.file.link"
                internal
                icon-position="right"
                size="s"
                target="_blank"
            >
                <span v-html="text['press-release']"></span>
            </z-link>
        </template>

    </div>
</div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'calendar-card',
    props: {
        data: {
            type: Object
        },
        theme: {
            type: String,
            default: 'upcoming',
            validator: prop => ['past', 'upcoming'].includes(prop)
        }
    },
    data () {
        return {
            text: {
                'press-release': localize({
                    en: 'Press release',
                    ru: 'Пресс-релиз'
                }),
                addToCalendar: localize({
                    ru: 'Добавить в календарь',
                    en: 'Add to calendar'
                })
            }
        }
    }
}
</script>

<style lang="scss">
.calendar-card {
    border: 1px solid $token-colors-tertiary;
    @include padding-level(top, M);
    @include padding-level(bottom, M);
    @include padding-level(left, M);
    @include padding-level(right, M);
    display: flex;
    flex-direction: column;
    height: 100%;

    @include breakpoint (v-tablet) {
        min-height: auto;
    }

    &__content {
        flex-grow: 1;
    }

    &__footer {
        flex-shrink: 0;
        margin-top: 130px;
        font-weight: 500;
    }

    &__title {
        color: $token-colors-black-90 !important;
        line-height: 1.3 !important;

        @include breakpoint (tablet) {
            font-size: 24px !important;
        }
    }

    &--theme-upcoming {
        background: $token-colors-secondary-bg;
        border-color: $token-colors-secondary-bg;
    }
}
</style>
